export type KeyValuePair = {
  key: string;
  value: string;
};

export type JsonBody = {
  jsBody: Record<string, unknown>;
};

export type WebhookUserJsonField = {
  field: string;
  deleted?: string;
};

export type UserFieldOption = {
  id: string;
  label: string;
  value: string;
};

export type WorkflowWebhookBody = KeyValuePair | JsonBody | WebhookUserJsonField;

export type Workflow = {
  id: number;
  name: string;
  workflowNodes: [
    {
      id: number;
    },
  ];
};

export type WorkflowNode = {
  id: number;
  workflow: Workflow;
};

export type WorkflowWebhook = {
  id?: number;
  name: string;
  endpoint: string;
  destination: string;
  method: string;
  contentType: string;
  authType: string;
  clientId: string;
  clientSecret?: string | null;
  tokenEndpoint: string;
  headers: KeyValuePair[];
  body: WorkflowWebhookBody[] | null;
  basicAuthToken: string;
  jsBody: string;
  includeDefaultFields: boolean;
  formBody: KeyValuePair[];
  userFields: WebhookUserJsonField[];
  workflowNodes?: WorkflowNode[];
  modifiedClientSecret?: boolean;
  modifiedCustomHeaders?: boolean;
};

export type CollapsableRowProps = {
  collapsed: boolean;
};

export enum EditMode {
  Create,
  EditName,
  EditWebhook,
}

export type WebhookKeyValuePairKey = 'headers' | 'formBody';

export type Errors = Record<string, boolean>;

export type NamePanelProps = {
  isEditing: boolean;
};
